module.exports = __webpack_public_path__ + "images/cart66e3de135c6076519690b775708f30b7.png";